var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "../styles";
import clsx from "../utils/clsx";
import { getCosmosDataProps } from "../utils/comsosCompat";
export var TextComponentName = "CosmosText";
export var useTextStyles = makeStyles(function (theme) { return ({
    code1: theme.typography.code1,
    code2: theme.typography.code2,
    light: {
        fontWeight: theme.typography.fontWeightLight,
    },
    regular: {
        fontWeight: theme.typography.fontWeightRegular,
    },
    medium: {
        fontWeight: theme.typography.fontWeightMedium,
    },
    semibold: {
        fontWeight: theme.typography.fontWeightSemibold,
    },
    bold: {
        fontWeight: theme.typography.fontWeightBold,
    },
}); }, { name: TextComponentName });
var isMuiVariant = function (variant) {
    return variant !== "code1" && variant !== "code2";
};
export var Text = React.forwardRef(function (props, ref) {
    var classes = useTextStyles(props);
    var children = props.children, variant = props.variant, weight = props.weight, className = props.className, textProps = __rest(props, ["children", "variant", "weight", "className"]);
    return (React.createElement(Typography, __assign({ ref: ref, className: clsx(variant && classes[variant], weight && classes[weight], className), variant: isMuiVariant(variant) ? variant : "inherit" }, getCosmosDataProps(variant && variant.startsWith("h") ? "heading" : "text"), textProps), children));
});
